import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English', flag: 'GB' },
  { code: 'fr', label: 'Français', flag: 'FR' },
  { code: 'da', label: 'Dansk', flag: 'DK' },
  { code: 'de', label: 'Deutsch', flag: 'DE' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const current = languages.find((l) => l.code === i18n.language?.split('-')[0]) || languages[0];

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  function select(code: string) {
    i18n.changeLanguage(code);
    setOpen(false);
  }

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        aria-label="Select language"
      >
        <span className="flex w-5 h-5 items-center justify-center">
          <i className="ri-global-line text-base"></i>
        </span>
        <span>{current.label}</span>
        <span className="flex w-4 h-4 items-center justify-center">
          <i className={`ri-arrow-down-s-line text-sm transition-transform ${open ? 'rotate-180' : ''}`}></i>
        </span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-40 rounded-lg border border-background-200 bg-background-50 py-1 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => select(lang.code)}
              className={`flex w-full items-center gap-2 px-4 py-2 text-sm text-left whitespace-nowrap cursor-pointer transition-colors ${
                current.code === lang.code
                  ? 'bg-primary-100 text-primary-700 font-semibold'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <span className="text-base">{lang.label}</span>
              {current.code === lang.code && (
                <span className="flex w-4 h-4 items-center justify-center ml-auto">
                  <i className="ri-check-line text-sm"></i>
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}